import { ActionTypes } from "../constants";
import { combineReducers } from "redux";
import { addOrReplace } from "../utilities/reducers";

const reduceNotes = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.GET_NOTES_SUCCESS:
            return action.data;

        case ActionTypes.GET_NOTE_SUCCESS:
            return addOrReplace(state, action.data);

        case ActionTypes.DELETE_NOTE_SUCCESS:
            const noteId = Number(action.payload.id);
            return state.filter(({ id }) => Number(id) !== noteId);

        case ActionTypes.LOGOUT:
            return [];

        default:
            return state;
    }
};

const reduceUploadNote = (state = false, action) => {
    switch (action.type) {
        case ActionTypes.ADD_NOTE_SUCCESS:
            return Number(action.data.id);

        case ActionTypes.UPDATE_NOTE_SUCCESS:
            return Number(action.payload.id);

        case ActionTypes.GET_NOTES_SUCCESS:
            return false;

        case ActionTypes.GET_NOTE_SUCCESS:
            if (!state) return state;
            return Number(action.data.id) !== state ? state : false;

        default:
            return state;
    }
};

const notes = combineReducers({
    notes: reduceNotes,
    uploading: reduceUploadNote,
});

export default notes;
export const getNotes = ({notes}) => notes;
export const getNote = ({notes}, noteId) => !notes || !Array.isArray(notes) ? null : notes.find(({id}) => Number(id) === noteId);
export const getUploadedNoteId = ({ uploading }) => uploading;
